import React from 'react';
import { Input, Select } from "component";
import { Controller, useFormContext } from 'react-hook-form';
import { formItem } from "template/footer/contact/formStatic";
import useLang from "hook/useLang";
function FooterContactUsForm() {
    var _a = useFormContext(), register = _a.register, control = _a.control;
    var lang = useLang();
    return (React.createElement(React.Fragment, null, formItem(lang.file.footer.contactUs).map(function (item) {
        if (item.input) {
            return (React.createElement(Input, { ref: register, key: item.id, id: item.id, "aria-label": item.placeholder, divClassName: 'mb-5', inputClassName: 'text-14 font-normal border rounded-md py-2 px-2', borderColorInput: 'border-black border-opacity-25 hover:border-opacity-100', inputMode: item.inputMode, textInput: item.textInput, placeholder: item.placeholder, rows: item.rows }));
        }
        else {
            return (React.createElement(Controller, { key: item.id, name: item.id, control: control, render: function (_a) {
                    var onChange = _a.onChange, value = _a.value;
                    return (React.createElement(Select, { className: 'mb-5 sm:mt-2 w-full', label: item.placeholder, data: item.data, value: value, onClick: function (value) {
                            onChange(value);
                        }, onCancel: function () {
                            onChange({});
                        } }));
                } }));
        }
    })));
}
export default FooterContactUsForm;
